import React, { useEffect, useState } from "react";
import { $accounts, $selectedAccountIdx } from "../../../common/accounts2";
import { useStore } from "effector-react";
import { empty } from "../../../common/functions";
import { PaymentListItem } from "../molecules/PaymentsListItem";
import { $transactions, queryGetTransactions, getTransactionsByYYYYMM, getPaymentsByYYYYMM } from "../logics/getTransactions";
import { ITransactionsByMonth } from "../logics/types";

const incrementCount = 3

//отрисовываем список начислений
export const PaymentsBlock = () => {
  const { accounts } = useStore($accounts);
  const accIdx = useStore($selectedAccountIdx);
  const transactions = useStore($transactions);
  const [byMonth,setByMonth]=useState<ITransactionsByMonth[]>([])
  const [hideAll, setHideAll] = useState(accIdx < 0 || empty(accounts));
  const [showCount, setShowCount] = useState(3)

  function showMorelCards() {
    let tranLen = transactions.transactionsByMonth.length
    setShowCount(showCount + incrementCount > tranLen ? tranLen : showCount + incrementCount)
  }

  /*useEffect(() => {
    queryGetTransactions(accounts[accIdx].id+'')
  }, [])*/

  useEffect(() => {
   console.log(transactions,showCount)
   setByMonth(transactions.transactionsByMonth)
  }, [transactions])

  useEffect(() => {
    console.log(accIdx,accounts,transactions)
    setHideAll(accIdx < 0 || empty(accounts) || transactions.transactionsByMonth.length == 0)
  }, [accounts, accIdx, transactions])

  return (
    <div hidden={hideAll} className="page__data-card">
      <h2 className="data-card__title" style={{ marginBottom: "10px" }}>Платежи</h2>
      <ul className="charges__list">
        {byMonth.slice(0, showCount).map((e, i) => {
          return  <PaymentListItem key={i} kopeikiByMonth={e.monthPayments} transactions={getPaymentsByYYYYMM(e.yyyymm)} yyyymm={e.yyyymm} />
        })}
      </ul>
      <button hidden={showCount === byMonth.length} type="button" onClick={showMorelCards} className="charges__button-more">
        Загрузить ещё...
      </button>
    </div>
  );
};
